import type { TData, TEvent, TYMData } from './models';
import { createReplacer } from './create-replacer';
import { createTemplater } from './create-templater';
import { collectSwitchData } from './collect-switch-data';
import { prepareData } from './preparers/prepare-data';
import { prepareYmData } from './preparers/prepare-ym-data';

/**
 * Подготовить данные для отправки события
 * @param event Конфигурация события на основе которй будет подготовлены данные
 * @param params Параметры коллбека инициатора события
 * @returns Готовый объект события
 */
export const prepareEventData = (
    event: TEvent,
    params?: unknown[]
): TData | { ymEvent: TYMData } => {
    const { data, switchData, ymData } = event;

    const replace = createReplacer(event, params);
    const applyTemplate = createTemplater(replace);

    const collectedSwitchData = collectSwitchData(replace, switchData);

    const collectedData = {
        ...data,
        ...collectedSwitchData,
    };

    const preparedData = prepareData<TData, string | number | boolean>(
        applyTemplate,
        collectedData
    );
    if (!ymData) return preparedData;

    const preparedYmData = prepareYmData(applyTemplate, ymData);

    return {
        ...preparedData,
        ymEvent: preparedYmData,
    };
};
